import { LOGS_URL } from "../constants";
import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { useSearchParams } from "react-router-dom";
import { useFetching } from "../hooks/useFetching";
import Loader from "./UI/Loader/Loader";
import { dateToUTCName, parseUTCNameToDate } from "../utils/logs";
import { useVariable } from "../hooks/useVariable";
import MySelect from "./UI/select/MySelect";
import MyInput from "./UI/input/MyInput";
import MyButton from "./UI/button/MyButton";
import cl from "../styles/GoogleCharts.module.css";

const GoogleCharts = () => {
  console.log("google charts");

  const [chartData, setChartData] = useState([["Second", "Value"]]);
  const [times, setTimes] = useState([]);
  const [live, setLive] = useState(false);

  const [timeA, setTimeA] = useState(new Date());
  const [timeDelta, setTimeDelta] = useState(1);//1 hour
  const [timeB, setTimeB] = useState(timeA.getTime() - timeDelta * 3600 * 1000);

  const [searchParams, setSearchParams] = useSearchParams();
  // const [varName, setVarName] = useState("");

  let varName = searchParams.get("var");
  const fromT = searchParams.get("from");
  const toT = searchParams.get("to");

  // console.log('toT '+toT);
  // console.log('fromT '+fromT);

  const liveValue = useVariable(varName);

  const [fetchLogFile, isLoading, error] = useFetching(async (toFetch) => {
    console.log("logs fetching");

    const newTimes = [];
    const result = await Promise.all(
      toFetch.map(async ({ date, fileName, url }) => {
        try {
          // console.log(`await: ${url}`);
          const resp = await fetch(url);
          if (!resp.ok) {
            console.log(`error: ${url}`);
            return null;
          }
          const text = await resp.text();
          const lines = text.trim().split("\n");
          // console.log(`resp: ${url}\n${text}`);
          const parsedData = lines.map((line) => {
            const [secondStr, valueStr] = line.trim().split(/\s+/);
            let seconds = parseInt(secondStr);
            const timeCode = new Date(date.getTime() + seconds * 1000);
            return [timeCode, parseFloat(valueStr)];
          });
          newTimes.push({
            date: date,
            fileName: fileName,
            url: url,
            data: parsedData,
          });
          // console.log(newTimes);
        } catch {
          console.log("catched error: ");
        }
      })
    );

    setTimes((prev) => {
      const merged = [...prev, ...newTimes];
      //sort
      merged.sort((a, b) => a.date - b.date);
      return merged;
    });
  });
  useEffect(() => {
    if (!fromT) {
      const fromT = new Date(); // Текущая дата и время
      fromT.setHours(fromT.getHours() - 1);
    }
    if (!toT) {
      setLive(true);
    }
    let start = parseUTCNameToDate(fromT);
    let end = toT ? new Date(toT) : new Date();

    const now = new Date();
    const past = new Date();
    const hoursGone = 1;
    past.setTime(now.getTime() - hoursGone * 3600 * 1000);

    start = past;
    end = now;
    setLive(false);
    console.log(`var: ${varName} \nfrom: ${start}\nend" ${end}`);

    const timeToFetch = [];
    let d = start;
    while (d <= end) {
      console.log(`d ${d}`);
      let fileName = `${varName}.${dateToUTCName(d)}`;
      let log_url = `${LOGS_URL}/${varName}/${fileName}`;

      //already loaded?
      if (!times.some((obj) => obj.fileName === fileName)) {
        timeToFetch.push({
          date: new Date(d),
          fileName: fileName,
          url: log_url,
        });
      }
      d.setUTCHours(d.getUTCHours() + 1);
    }
    fetchLogFile(timeToFetch);
  }, [varName]);

  useEffect(() => {
    console.log("baking chart data");

    const rows = [["Second", "Value"]]; // Заголовок для графика

    // console.log(`times: ${times}`);

    times.forEach(({ data }) => {
      if (Array.isArray(data)) {
        rows.push(...data); // добавляем массивы [timeCode, value]
      }
    });

    setChartData(rows);
  }, [times]);

  // useEffect(() => {
  //   console.log(chartData);
  // }, [chartData]);

  useEffect(() => {
    //add live value
    if (live) {
      console.log("live value changed: " + liveValue);

      setChartData((prev) => [...prev, [new Date(), liveValue]]);
    }
  }, [live, liveValue]);

  return (
    <div style={{ width: "100%", marginTop: "50px" }}>
      <div>{live ? "Live" : "Archive"}</div>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <div>error loading {error}</div>
      ) : (
        <Chart
          className={cl.chart}
          chartType="LineChart"
          width="100%"
          height="380px"
          data={chartData}
          options={{
            title: varName,
            hAxis: {
              title: "Время",
              format: "HH:mm:ss", // или просто "short"
            },
            vAxis: { title: "Значение" },
            legend: "none",
          }}
          chartLanguage="ru"
        />
      )}
      <div className={cl.controlsWrapper}>
        <MyButton>Назад</MyButton>
        <MyButton>Вперед</MyButton>
      </div>
    </div>
  );
};

export default GoogleCharts;
